export function bannerRedirection(banner_data) {
    var url_redirection = '';
    switch (banner_data?.screen?.code) {
      case 'account':
        url_redirection = '/profile';
        break;
  
      case 'addBalance':
        url_redirection = '';
        break;
  
      case 'addChangeUsernamePopup':
        url_redirection = '';
        break;
  
      case 'allGames':
        url_redirection = '';
        break;
  
      case 'applyPromoCodePopup':
        url_redirection = '';
        break;
  
      case 'coinStore':
        url_redirection = '/rewards';
        break;
  
      case 'collegeLeagues':
        url_redirection = '';
        break;
  
      case 'collegeLeaguesDetails':
        url_redirection = '/';
        break;
  
      case 'contestDetails':
        url_redirection = '/contest/list';
        break;
  
      case 'contestsList':
        localStorage.setItem("activeGameId", banner_data?.game);
        localStorage.setItem("activeGame", banner_data?.gameName);
        localStorage.setItem("activeGameTypeName", banner_data?.gameTypeName);
        localStorage.setItem("activeGameType", JSON.stringify(banner_data?.gameType));
        url_redirection = '/contest/list';
        break;
  
      case 'customerCare':
        url_redirection = '/more/customer-care';
        break;
  
      case 'dailyLoginRewards':
        url_redirection = '/rewards';
        break;
  
      case 'dailyLoginRewardsPopup':
        url_redirection = '';
        break;
  
      case 'dobAndStateValidation':
        url_redirection = '';
        break;
  
      case 'editProfile':
        url_redirection = '/edit/profile';
        break;
  
      // Logic for World of eSports Sub Screens
      case 'esportsNewsDetails':
        url_redirection = '/world-of-eports/esports-news';
        break;
  
      case 'friends':
        url_redirection = '/friends';
        break;
  
      case 'gameType':
        url_redirection = '';
        break;
  
      case 'gamerjiPoints':
        url_redirection = '/more/vipoints';
        break;
  
      case 'htmlCategories':
        url_redirection = '';
        break;
  
      case 'htmlGames':
        url_redirection = '/htmlFreeGames';
        break;
  
      case 'howToPlay':
        url_redirection = '';
        break;
  
      case 'infoPopup':
        url_redirection = '';
        break;
  
      case 'joinContestWalletPopup':
        url_redirection = '';
        break;
  
      case 'joinTournamentWalletPopup':
        url_redirection = '';
        break;
  
      case 'joinViaInviteCodePopup':
        url_redirection = '';
        break;
  
      case 'leaderboard':
        url_redirection = '/more/leaderboard';
        break;
  
      case 'legality':
        url_redirection = '/more/terms-of-use';
        break;
  
      case 'linkBankOrUpiAccount':
        url_redirection = '';
        break;
  
      case 'mobileAndEmailVerify':
        url_redirection = '';
        break;
  
      case 'more':
        url_redirection = '/more';
        break;
  
      case 'myContests':
        localStorage.setItem("activeGameId", banner_data?.game);
        localStorage.setItem("activeGame", banner_data?.gameName);
        localStorage.setItem("activeGameTypeName", banner_data?.gameTypeName);
        localStorage.setItem("activeGameType", JSON.stringify(banner_data?.gameType));
        url_redirection = '/my-contest/list/' + banner_data?._id;
        break;
  
      case 'myRecentTransactions':
        url_redirection = '/rewards/my-recent-transactions';
        break;
  
      case 'myRewards':
        url_redirection = '/rewards';
        break;
  
      case 'otherUserProfile':
        url_redirection = '/user-profile';
        break;
  
      case 'paymentGateway':
        url_redirection = '';
        break;
  
      case 'paymentOptions':
        url_redirection = '';
        break;
  
      case 'prizePoolPopup':
        url_redirection = '';
        break;
  
      case 'profile':
        url_redirection = '/profile';
        break;
  
      case 'profileInsights':
        url_redirection = '/profile';
        break;
  
      case 'raiseAComplaint':
        url_redirection = '/more/customer-care';
        break;
  
      case 'redeemRewardsPopup':
        url_redirection = '';
        break;
  
      case 'rewardStore':
        url_redirection = '/rewards';
        break;
  
      case 'rulesPopup':
        url_redirection = '';
        break;
  
      case 'selectFavoriteGamePopup':
        url_redirection = '';
        break;
  
      case 'singleContest':
        url_redirection = '';
        break;
  
      case 'singleTournament':
        url_redirection = '';
        break;
  
      case 'squadRegistration':
        url_redirection = '';
        break;
  
      case 'streamOnGamerji':
        url_redirection = '';
        break;
  
      case 'ticketDetails':
        url_redirection = '/more/customer-care';
        break;
  
      case 'tournamentDetails':
        url_redirection = '/tournament/list';
        break;
  
      case 'tournamentLists':
        localStorage.setItem("activeGameId", banner_data?.game);
        localStorage.setItem("activeGame", banner_data?.gameName);
        localStorage.setItem("activeGameTypeName", banner_data?.gameTypeName);
        localStorage.setItem("activeGameType", JSON.stringify(banner_data?.gameType));
        url_redirection = '/tournament/list';
        break;
  
      case 'tournamentTimingPopup':
        url_redirection = '';
        break;
  
      case 'URLRedirect':
        url_redirection = '';
        break;
  
      case 'updateEmailPopup':
        url_redirection = '';
        break;
  
      case 'verifyEmail':
        url_redirection = '';
        break;
  
      case 'videos':
        url_redirection = '/world-of-eports';
        break;
  
      // 
      case 'viewAllEsportsNews':
        url_redirection = '/world-of-eports/esports-news';
        break;
  
      case 'viewAllMedals':
        url_redirection = '';
        break;
  
      // 
      case 'viewAllTopProfiles':
        url_redirection = '/world-of-eports/user-profile';
        break;
  
      // 
      case 'viewAllVideos':
        url_redirection = '/world-of-eports/popularvideos';
        break;
  
      case 'withdrawal':
        url_redirection = '';
        break;
  
      case 'worldOfEsports':
        url_redirection = '/world-of-eports';
        break;
  
      case 'directDownloadAPKs':
        url_redirection = '';
        break;
  
    }
    return url_redirection;
  }